// AppRoute.js
import React, { Component, Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Detail from './pages/Detail/Detail';
import Search from './pages/Search/Search';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import AccountSettings from './pages/AccountSettings/AccountSettings';
import TvLogin from './pages/TvLogin/TvLogin';
import Price from './pages/Price/Price';
import Watch from './pages/watch/watch';
import AuthGuard from './utils/AuthGuard';
import DeleteAccount from './pages/DeleteAccount';
import MembershipWatchGuard from './utils/MembershipWatchGuard'; // Premium + Login guard

class AppRoute extends Component {
  render() {
    return (
      <Fragment>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Fully Auth Protected Routes */}
          <Route element={<AuthGuard />}>
            <Route path="/details/:slug" element={<Detail />} />
            <Route path="/search/:key" element={<Search />} />
            <Route path="/profile" element={<AccountSettings />} />
            <Route path="/tv/setup" element={<TvLogin />} />
            <Route path="/subscricption" element={<Price />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
          </Route>

          {/* Watch Routes */}
          {/* 1. Promo: Public (no login, no membership needed) */}
          {/* <Route path="/watch/promo/:flimId" element={<Watch />} />
          <Route path="/watch/promo/:flimId/:episodeId" element={<Watch />} /> */}

          {/* 2. All other watch types: Require Login + Premium Membership */}
          <Route element={<MembershipWatchGuard />}>
            <Route path="/watch/:type/:flimId" element={<Watch />} />
            <Route path="/watch/:type/:flimId/:episodeId" element={<Watch />} />
          </Route>
        </Routes>
      </Fragment>
    );
  }
}

export default AppRoute;